export function captureRecruitmentContext(rootState = {}) {
	const user = rootState.user?.user
	const request = {
		sessionGeneration: rootState.application?.sessionGeneration,
		userId: user?.id,
		organizationId: user?.current_organization?.id,
		accountType: user?.type
	}
	return () => {
		const currentUser = rootState.user?.user
		return (
			request.sessionGeneration ===
				rootState.application?.sessionGeneration &&
			request.userId === currentUser?.id &&
			request.organizationId === currentUser?.current_organization?.id &&
			request.accountType === currentUser?.type
		)
	}
}

export const mergeOrganizationContext = (previous, organization) => {
	if (!organization) return null
	const preservePrevious =
		String(previous?.id) === String(organization.id) &&
		!Object.prototype.hasOwnProperty.call(organization, 'capabilities')
	return { ...(preservePrevious ? previous : {}), ...organization }
}

const organizationAccessKey = organization => {
	const canonical = Object.prototype.hasOwnProperty.call(
		organization || {},
		'capabilities'
	)
	const permissions = canonical
		? Object.keys(organization.capabilities || {}).filter(
				ability => organization.capabilities[ability] === true
		  )
		: Array.isArray(organization?.permissions)
		? [...organization.permissions]
		: []
	return JSON.stringify([
		String(organization?.id ?? ''),
		String(organization?.member_id ?? organization?.member?.id ?? ''),
		organization?.effective_role ??
			organization?.role_in_organization ??
			null,
		organization?.is_support_login === true,
		canonical,
		permissions.sort()
	])
}

export const organizationAccessChanged = (previous, organization) =>
	organizationAccessKey(previous) !== organizationAccessKey(organization)

export const resetRecruitmentContext = commit => {
	commit('notification/RESET_STATE', null, { root: true })
	commit('application/RESET_STATE', null, { root: true })
	commit('jobOffer/RESET_STATE', null, { root: true })
	commit('assessmentInvitation/setInvitations', [], { root: true })
	commit('activateJobOffer/RESET_STATE', null, { root: true })
}
